// Tous les articles de blog migrés depuis perspective-assurance.fr/blog
// Triés du plus récent au plus ancien.

export const POSTS = [
  {
    slug: "terrassement-decennale",
    title: "Les risques en assurance décennale liés à l'activité de terrassement",
    excerpt: "Le terrassement est l'une des étapes les plus importantes d'un chantier. Une erreur à ce stade peut engager directement la responsabilité décennale de l'entreprise.",
    date: "2026-06-08",
    dateLabel: "8 juin 2026",
    image: "https://primary.jwwb.nl/public/g/f/r/temp-rlggvefjiggdfactyuqq/pub-terrassement-decennale-high.webp",
    category: "Décennale par métier",
    metaTitle: "Risques décennale en terrassement | Perspective Assurance",
    metaDescription: "Pourquoi le terrassement engage la responsabilité décennale. Sinistres typiques, conséquences et comment se protéger.",
    content: `Le terrassement constitue l'une des étapes les plus importantes d'un chantier de construction. Souvent considéré comme un simple travail préparatoire, il joue pourtant un rôle fondamental dans la stabilité et la pérennité de l'ouvrage. Une erreur à ce stade peut entraîner des conséquences lourdes, engageant directement la responsabilité décennale de l'entreprise.

## Pourquoi le terrassement est-il concerné par la garantie décennale ?

La garantie décennale couvre pendant 10 ans les dommages qui compromettent la solidité de l'ouvrage ou le rendent impropre à sa destination. Les travaux de terrassement entrent pleinement dans ce cadre lorsqu'ils participent à la stabilité des constructions.

Un terrassement mal réalisé peut provoquer :

- Des tassements différentiels du terrain
- Des fissurations importantes des murs et fondations
- Des affaissements de dallages
- Des glissements de terrain
- Des problèmes de drainage et d'infiltration d'eau
- Une déstabilisation des ouvrages voisins

## Les principaux sinistres rencontrés

### 1. Mauvaise étude du sol
L'absence ou la mauvaise interprétation d'une étude géotechnique peut conduire à des erreurs de conception : apparition de fissures structurelles ou mouvements du bâtiment plusieurs années après la réception.

### 2. Compactage insuffisant
Un remblai mal compacté est l'une des causes les plus fréquentes de sinistres. Avec le temps, le sol se tasse progressivement : affaissement des plateformes, dallages ou voiries.

### 3. Gestion défaillante des eaux
Le terrassement modifie l'écoulement naturel des eaux. Une mauvaise évacuation peut entraîner des infiltrations, des érosions ou une déstabilisation des fondations.

### 4. Atteinte aux réseaux enterrés
Lors des travaux de fouilles, l'endommagement de réseaux existants génère des coûts considérables et des litiges importants.

## Comment limiter les risques ?

- Réaliser systématiquement les études de sol nécessaires
- Respecter les prescriptions géotechniques
- Mettre en œuvre des procédures rigoureuses de compactage
- Contrôler les pentes et les systèmes d'évacuation
- Conserver l'ensemble des justificatifs techniques
- Vérifier que votre contrat couvre précisément les activités exercées

## L'importance d'une assurance décennale adaptée

Toutes les assurances décennales ne proposent pas les mêmes garanties. Les activités de terrassement présentent des risques spécifiques qui nécessitent une analyse précise du métier et des chantiers. Choisir un contrat inadapté peut entraîner des exclusions particulièrement problématiques lors d'un sinistre.`
  },
  {
    slug: "bureau-etude-decennale",
    title: "Quels risques en décennale pour un bureau d'étude ?",
    excerpt: "Erreur de calcul, défaut de conception, mauvaise étude thermique ou structurelle : un défaut technique peut engager la responsabilité du BET pendant 10 ans.",
    date: "2026-05-06",
    dateLabel: "6 mai 2026",
    image: "https://primary.jwwb.nl/public/g/f/r/temp-rlggvefjiggdfactyuqq/pub-bet-decennale-high.webp",
    category: "Décennale par métier",
    metaTitle: "Décennale bureau d'étude (BET) — Risques & garanties | Perspective Assurance",
    metaDescription: "Décennale BET structure, fluides, thermique, électricité, VRD : risques, exemples de sinistres, comment bien s'assurer.",
    content: `Dans le secteur du bâtiment, les bureaux d'étude techniques (BET) jouent un rôle essentiel dans la conception, le dimensionnement et la sécurisation des projets. Pourtant, beaucoup sous-estiment encore leur niveau de responsabilité en matière d'assurance décennale.

Erreur de calcul, défaut de conception, mauvaise étude thermique ou structurelle : un simple défaut technique peut engager la responsabilité du bureau d'étude pendant 10 ans après la réception des travaux.

## La responsabilité décennale d'un bureau d'étude

La garantie décennale est obligatoire pour tous les professionnels participant à la conception ou à la réalisation d'un ouvrage. Contrairement aux idées reçues, les BET ne sont pas seulement des "conseillers techniques" : leur responsabilité peut être engagée au même titre qu'une entreprise de travaux.

Exemples fréquents :
- Fissures liées à un mauvais calcul de structure
- Infiltration causée par une étude défaillante
- Problème de conformité thermique
- Défaut de stabilité d'un ouvrage
- Erreurs de dimensionnement des réseaux techniques

## BET Structure
Le bureau d'étude structure est l'un des plus exposés. Il intervient sur fondations, calculs béton, charpentes métalliques, structures bois, stabilité générale.
**Risques** : affaissement, fissuration, défaut de portance, effondrement partiel, erreurs de calcul.

## BET Fluides
Chauffage, ventilation, climatisation, plomberie, désenfumage, hydraulique.
**Risques** : condensation, moisissures, surconsommation, défaut de ventilation, dégâts des eaux.

## BET Thermique
Avec la RE2020, les BET thermique sont incontournables : études énergétiques, calculs, simulations, audits.
**Risques** : non-respect des normes, mauvaise performance, inconfort thermique, refus de conformité.

## BET Électricité
**Risques** : non-conformité, surcharge réseau, défaillance sécurité, risques d'incendie, défauts d'alimentation.

## BET VRD
Réseaux enterrés, assainissement, eaux pluviales, voiries.
**Risques** : défaut d'évacuation, affaissement de voirie, inondations, erreurs d'implantation.

## Comment bien choisir son assurance décennale BET ?

Une bonne assurance doit :
- Couvrir précisément les missions déclarées
- Protéger les études d'exécution et de conception
- Inclure les activités annexes
- Prévoir des plafonds adaptés
- Limiter les exclusions techniques

Le prix est important, mais la qualité des garanties l'est encore plus.`
  },
  {
    slug: "dommage-ouvrage-pourquoi-souscrire",
    title: "L'assurance dommage ouvrage : pourquoi doit-on y souscrire ?",
    excerpt: "L'assurance DO permet d'être indemnisé rapidement en cas de sinistre relevant de la décennale, sans attendre qu'un tribunal détermine les responsabilités.",
    date: "2026-04-20",
    dateLabel: "20 avril 2026",
    image: "https://primary.jwwb.nl/public/g/f/r/temp-rlggvefjiggdfactyuqq/image-do-2-high.jpg",
    category: "Maîtres d'ouvrage",
    metaTitle: "Assurance dommage ouvrage (DO) — Pourquoi souscrire ? | Perspective Assurance",
    metaDescription: "Dommage ouvrage, décennale, TRC, CNR : comprendre les garanties indispensables pour sécuriser votre construction ou rénovation.",
    content: `Lorsque l'on lance un projet de construction ou de rénovation lourde, l'enthousiasme prend souvent le dessus sur les aspects assurantiels. Pourtant, un chantier comporte toujours des risques techniques, financiers et réglementaires. Souscrire une **assurance dommage ouvrage (DO)** permet justement de sécuriser son projet et d'éviter des situations longues et coûteuses en cas de sinistre.

## Qu'est-ce que l'assurance dommage ouvrage ?

L'assurance dommage ouvrage est **obligatoire** pour toute personne faisant réaliser des travaux de construction importants. Elle permet d'être **indemnisé rapidement**, sans attendre qu'un tribunal détermine la responsabilité des intervenants, en cas de sinistre relevant de la garantie décennale.

Elle couvre notamment :
- Les fissures importantes compromettant la solidité
- Les affaissements de plancher
- Les infiltrations liées à un défaut structurel
- Les défauts d'étanchéité majeurs
- Les problèmes de fondations

## Une assurance obligatoire avant le chantier

La DO est imposée par la loi avant l'ouverture du chantier pour les constructions neuves, les extensions importantes et certaines rénovations structurelles.

Sans elle, vous vous exposez à :
- Une revente difficile du bien pendant 10 ans
- Une responsabilité financière directe en cas de sinistre
- Des délais d'indemnisation très longs

## La garantie décennale : la base du système

Souscrite par les entreprises, elle couvre pendant 10 ans les dommages compromettant la solidité, la stabilité, l'étanchéité et l'usage normal du bâtiment. Cependant, elle ne permet pas une indemnisation immédiate. **La DO préfinance les réparations, puis se retourne contre les assureurs décennaux.**

## La TRC (Tous Risques Chantier)

Couvre les dommages matériels pouvant survenir **pendant la construction** : incendie, vol, effondrement partiel, intempéries, erreurs d'exécution. Particulièrement recommandée pour les opérations immobilières et chantiers techniques.

## La CNR (Constructeur Non Réalisateur)

Concerne les maîtres d'ouvrage professionnels (promoteurs, marchands de biens, vendeurs après rénovation) qui font construire sans réaliser eux-mêmes les travaux. Couvre leur responsabilité décennale vis-à-vis des acquéreurs.

## Un atout majeur pour la revente

Lors d'une vente dans les 10 ans suivant la construction, le notaire vérifie son existence et l'acheteur est rassuré. Sans DO, la vente peut être retardée et le prix baisser.

## Conclusion

Souscrire une DO n'est pas une simple formalité : c'est une vraie stratégie de sécurisation. Associée à la décennale, la TRC et la CNR, elle constitue un dispositif complet couvrant chantier, réception et 10 années suivantes.`
  },
  {
    slug: "maitrise-oeuvre-decennale",
    title: "L'assurance décennale et la maîtrise d'œuvre",
    excerpt: "Le maître d'œuvre porte une responsabilité technique majeure. RC Pro et décennale sont indispensables pour exercer en sécurité.",
    date: "2026-03-23",
    dateLabel: "23 mars 2026",
    image: "https://primary.jwwb.nl/public/g/f/r/temp-rlggvefjiggdfactyuqq/maitre-doeuvre-high.jpg",
    category: "Décennale par métier",
    metaTitle: "Assurance maître d'œuvre — RC Pro & Décennale | Perspective Assurance",
    metaDescription: "Maître d'œuvre : RC Pro et décennale obligatoires. Tarifs, devis, création d'activité : tout savoir pour exercer sereinement.",
    content: `Le métier de **maître d'œuvre** implique une responsabilité technique majeure sur les projets de construction. En France, il est indispensable de souscrire une **RC Pro** et une **assurance décennale (RCD)** pour exercer en toute sécurité.

## La RC Pro maître d'œuvre

Couvre les dommages causés aux clients ou aux tiers pendant l'exercice de la mission, notamment :
- Erreur de conception technique
- Défaut de conseil
- Omission dans les plans
- Mauvaise coordination des entreprises
- Retard dans la gestion du chantier
- Préjudice financier au maître d'ouvrage

C'est souvent la première attestation demandée par les clients professionnels.

## La garantie décennale maître d'œuvre

Couvre pendant 10 ans les dommages compromettant la solidité, l'étanchéité, la structure ou l'usage normal du bâtiment. Même sans réaliser les travaux, votre responsabilité peut être engagée dès lors que vous intervenez sur :
- La conception technique
- La validation des choix constructifs
- La direction d'exécution
- La coordination des entreprises

## Une attestation indispensable pour obtenir des chantiers

Aujourd'hui, la majorité des maîtres d'ouvrage demandent :
- Une RC Pro valide
- Une décennale en cours
- Une couverture adaptée aux missions

Sans ces garanties, signer un contrat, intervenir sur un chantier ou répondre à un appel d'offres devient difficile.

## Quel prix ?

Le tarif dépend du chiffre d'affaires, expérience, missions, type d'ouvrages, historique et statut. Bonne nouvelle : il est possible d'obtenir une assurance avec devis rapide même pour les sociétés en création.

## En création d'activité ?

Il est possible d'obtenir une RC Pro immédiate, une décennale adaptée et une attestation rapide pour démarrer les chantiers — à condition de présenter un dossier correctement constitué.`
  },
  {
    slug: "cuisinistes-poseurs-salles-bains-decennale",
    title: "Quels risques pour les cuisinistes et poseurs de salles de bains en décennale ?",
    excerpt: "Étanchéité, plomberie, électricité, mobilier encastré : les agencements de cuisine et salle de bain engagent la décennale du professionnel.",
    date: "2026-02-08",
    dateLabel: "8 février 2026",
    image: "https://primary.jwwb.nl/public/g/f/r/temp-rlggvefjiggdfactyuqq/cuisiniste-d-cennale-high.jpg",
    category: "Décennale par métier",
    metaTitle: "Cuisinistes & salles de bains : risques décennale | Perspective Assurance",
    metaDescription: "Pose de cuisines, salles de bains, étanchéité : les risques en décennale et l'importance d'un contrat adapté à votre métier.",
    content: `L'agencement d'une cuisine ou d'une salle de bain est un projet important. Au-delà de l'esthétique, ces travaux touchent à la plomberie, l'électricité, l'étanchéité ou la pose de mobilier. Pour sécuriser ces installations, il est essentiel de disposer d'une **assurance décennale**.

## Qu'est-ce que l'assurance décennale ?

Garantie obligatoire pour les professionnels du bâtiment, elle couvre pendant 10 ans les dommages pouvant compromettre la solidité ou rendre l'ouvrage impropre à son utilisation. Dans une cuisine ou salle de bain, cela concerne :
- Les problèmes d'étanchéité
- Les infiltrations d'eau
- Les défauts de pose
- Les installations encastrées
- Certains éléments de plomberie ou d'électricité

## L'agencement de cuisine : un travail technique

La pose comprend la préparation des murs/sols, plans de travail, électroménager encastré, plomberie, évacuation, électricité, éclairage, crédence, finitions. Une mauvaise installation peut entraîner fuites, problèmes électriques, dégradation des meubles, infiltrations.

## Salle de bain : risques encore plus élevés

C'est la pièce la plus exposée à l'humidité. Une mauvaise réalisation provoque rapidement infiltrations, moisissures, décollement de carrelage, problèmes d'étanchéité douche/baignoire.

## Dommages structurels liés à la rénovation

Modification de cloisons, perçage de murs porteurs, réseaux encastrés, travaux sur supports. En cas de fissures ou affaissement, la responsabilité du pro est engagée 10 ans.

## Pourquoi choisir un artisan avec décennale ?

✔️ Sécurité pour le client en cas de malfaçon
✔️ Travaux dans les règles de l'art
✔️ Valorisation du bien à la revente
✔️ Confiance et transparence (attestation fournie systématiquement)`
  },
  {
    slug: "photovoltaique-decennale",
    title: "Photovoltaïque et assurance décennale : ce qu'il faut savoir",
    excerpt: "Dès qu'une installation photovoltaïque est fixée au bâti, elle devient un ouvrage soumis à l'assurance décennale. ETN, puissances, risques : décryptage.",
    date: "2025-11-15",
    dateLabel: "15 novembre 2025",
    image: "https://primary.jwwb.nl/public/g/f/r/temp-rlggvefjiggdfactyuqq/assurance-d-cennale-photovoltaique-standard.jpg",
    category: "Décennale par métier",
    metaTitle: "Décennale photovoltaïque — Risques & ETN | Perspective Assurance",
    metaDescription: "Photovoltaïque : assurance décennale obligatoire. Risques d'infiltration, électriques, ETN, classes de puissance. Devis spécialisé.",
    content: `Le marché du photovoltaïque connaît une croissance spectaculaire. Mais derrière cet engouement se cachent des obligations d'assurance et des risques techniques bien réels.

## Une activité soumise à l'assurance décennale

Dès lors qu'une installation photovoltaïque est **fixée au bâti**, elle devient un **ouvrage** au sens du Code civil. L'assurance décennale est obligatoire et couvre pendant 10 ans :
- La solidité du bâtiment
- L'étanchéité de la toiture
- L'aptitude à produire de l'électricité
- La sécurité électrique

## Les risques les plus fréquents

### 1. Infiltrations et défauts d'étanchéité
Sinistre n°1 : perçages, fixations ou raccords défectueux créent des infiltrations, humidité, moisissures, affaiblissement de la charpente.

### 2. Risques électriques
Câblage incorrect ou mauvais dimensionnement : échauffements, incendies, surtensions, panne totale.

### 3. Arrachement par le vent
Mauvaise fixation : dépose/arrachement, dégâts sur toiture, risques pour les personnes.

### 4. Perte de production
Installation qui ne produit pas conformément (matériel défaillant, montage, sous-dimensionnement) : ouvrage impropre à sa destination.

## Les classes de puissance

- **≤ 3 kWc** : résidentiel petite puissance, rarement éligible chez les pros
- **3 à 36 kWc** : catégorie la plus courante, zone rouge pour assureurs
- **36 à 500 kWc** : tertiaire, agricole, PME — formations et qualifications exigées
- **> 500 kWc** : industriel, centrales — dossiers renforcés

## Les ETN : un élément clé pour être couvert

Les **Évaluations Techniques Non traditionnelles (ETN)** décrivent les procédés non couverts par les DTU classiques. Si l'entreprise pose un système photovoltaïque sans respecter les ETN ou avec un matériel non certifié :
- L'assureur peut refuser la prise en charge
- L'entreprise peut être considérée comme ayant mal exécuté l'ouvrage

**Suivre les ETN = être couvert. Les ignorer = engager sa responsabilité.**

## Conclusion

Trois règles pour travailler sereinement :
1. Une décennale adaptée à votre type d'installations
2. Respect strict des normes, Avis Techniques et ETN
3. Une veille technique régulière`
  },
  {
    slug: "architectes-interieur-rc-pro-decennale",
    title: "RC Pro ou décennale pour les architectes d'intérieur ?",
    excerpt: "Décoration ou modifications structurelles : les garanties nécessaires ne sont pas les mêmes. Sinistres concrets et bons réflexes.",
    date: "2025-10-14",
    dateLabel: "14 octobre 2025",
    image: "https://primary.jwwb.nl/public/g/f/r/temp-rlggvefjiggdfactyuqq/t-l-chargement-standard.jpg",
    category: "Décennale par métier",
    metaTitle: "Architecte d'intérieur : RC Pro ou décennale ? | Perspective Assurance",
    metaDescription: "Architectes d'intérieur : sinistres typiques en RC Pro et décennale, quand l'une ou l'autre s'impose, comment bien se protéger.",
    content: `L'architecture d'intérieur est passionnante mais exposée à de nombreux risques. Entre une simple mission de décoration et un projet impliquant des modifications structurelles, les garanties nécessaires diffèrent.

## RC Pro : les risques liés à la prestation intellectuelle

Couvre les fautes, erreurs, omissions ou négligences :
- **Erreur de conception** : matériau inadapté en cuisine pro
- **Conseil erroné** : revêtement glissant dans un hall provoquant une chute
- **Retard contractuel** : suspension du chantier et frais supplémentaires

## Décennale : les risques liés au bâti

Dès lors que l'architecte d'intérieur conçoit, modifie ou coordonne des travaux affectant le gros œuvre ou la destination du bâtiment, la décennale est obligatoire.

### Exemples concrets

1. **Affaiblissement structure** : abattre une cloison "non porteuse" qui l'est en réalité → fissures sur les murs porteurs.
2. **Infiltrations** : déplacement d'une salle de bain avec évacuations mal intégrées → fuites chez le voisin du dessous.
3. **Mezzanine mal dimensionnée** : charges non calculées → plancher qui se déforme.
4. **Isolation/ventilation** : cloison sans VMC en SDB → moisissures.
5. **Escalier modifié** : marches non conformes → fissures et danger.

## Comment choisir ?

- **Mission décorative pure** (couleurs, mobilier) → RC Pro suffit
- **Mission impliquant des travaux** (structure, réseaux, pièces d'eau, extension) → RC Pro + décennale **obligatoires**

En pratique, beaucoup d'architectes d'intérieur exercent les deux types : souscrire les deux assurances est la meilleure protection.

## Conclusion

La frontière entre décoration et travaux est parfois fine. Pour éviter les mauvaises surprises : RC Pro pour les erreurs professionnelles + décennale dès que vous touchez au bâti.`
  },
  {
    slug: "electricien-decennale",
    title: "L'assurance décennale et l'activité d'électricien",
    excerpt: "Installation encastrée, tableau, domotique, plancher chauffant : l'électricien est largement concerné par la décennale. Sinistres concrets.",
    date: "2025-09-12",
    dateLabel: "12 septembre 2025",
    image: "https://primary.jwwb.nl/public/g/f/r/temp-rlggvefjiggdfactyuqq/d-cennale-electricien-standard.jpg",
    category: "Décennale par métier",
    metaTitle: "Décennale électricien — Sinistres et obligations | Perspective Assurance",
    metaDescription: "Électricien : quand la décennale est obligatoire, exemples de sinistres (incendie, mise à la terre, tableau), comment bien s'assurer.",
    content: `Dans le bâtiment, l'assurance décennale est obligatoire pour de nombreux professionnels, et les électriciens ne font pas exception.

## Qu'est-ce que l'assurance décennale ?

Garantie obligatoire couvrant pendant **10 ans à compter de la réception** les dommages qui compromettent la solidité ou rendent l'ouvrage impropre à sa destination. Le maître d'ouvrage peut faire jouer la garantie sans prouver de faute.

## Les électriciens sont-ils concernés ?

**Oui**, dès lors que l'installation électrique est encastrée, intégrée à la structure, ou joue un rôle essentiel dans la sécurité ou l'usage. Exemples :
- Installation défectueuse provoquant un incendie
- Défaut d'isolation mettant en danger les occupants
- Panne généralisée rendant un logement inhabitable

## Quand la décennale est-elle obligatoire ?

- Installation dans une construction neuve
- Rénovation complète du système électrique
- Travaux encastrés dans murs, planchers, plafonds
- Chantier CCMI ou marché public

Pour les **interventions ponctuelles** (changement de prise, dépannage simple), elle ne s'applique pas forcément.

## Exemples de sinistres concrets

### 🔥 Incendie par défaut d'installation encastrée
Mauvaise connexion entre câbles dans une cloison → échauffement → incendie 2 ans après réception. **Décennale engagée.**

### ⚡ Mise à la terre défaillante
Logement neuf mal relié à la terre → chocs électriques. **Ouvrage impropre à sa destination.**

### 💡 Panne d'un système domotique intégré
Mauvaise programmation/câblage → panne générale 6 mois après. **Logement partiellement inutilisable.**

### 🔌 Tableau électrique défaillant
Mauvais montage → coupure complète 3 ans après. **Élément indissociable de l'ouvrage.**

### 🌧️ Infiltration via passages de câbles mal étanchés
Fourreaux traversant une dalle non étanchéifiés → dégâts dans planchers et murs.

### 🔁 Plancher chauffant électrique défaillant
Panne 3 ans après réception, réparation nécessitant de casser le sol. **Couvert.**

## Comment bien choisir ?

- Vérifiez l'étendue des garanties (neuf, rénovation, encastré, domotique)
- Attention au montant des franchises
- Déclarez précisément votre activité pour éviter un refus de prise en charge`
  },
  {
    slug: "etancheite-risque-lourd-decennale",
    title: "L'étanchéité, un risque lourd en assurance décennale",
    excerpt: "Toiture, terrasse, façade, sous-sol : un défaut d'étanchéité peut entraîner des sinistres extrêmement coûteux. Étanchéité à chaud vs à froid.",
    date: "2025-08-20",
    dateLabel: "20 août 2025",
    image: "https://primary.jwwb.nl/public/g/f/r/temp-rlggvefjiggdfactyuqq/etancheur-assurance-decennale-standard.png",
    category: "Décennale par métier",
    metaTitle: "Étanchéité et décennale — Risque lourd | Perspective Assurance",
    metaDescription: "Étanchéité : pourquoi c'est un risque lourd en décennale, à chaud vs à froid, impact sur la prime et conseils de courtier.",
    content: `Quand on parle de construction, un mot revient souvent : **l'étanchéité**. Toiture, terrasse, façade, sous-sol — un défaut peut engendrer des sinistres majeurs : infiltrations, moisissures, dégradations structurelles, perte d'habitabilité.

## Pourquoi l'étanchéité est un point sensible

La responsabilité décennale impose aux constructeurs d'être garantis 10 ans après réception pour tout dommage compromettant la solidité de l'ouvrage ou le rendant impropre à sa destination. Les problèmes d'étanchéité entrent largement dans ce champ.

## Un "risque lourd"

En décennale, on qualifie de "risque lourd" les activités présentant une **probabilité élevée de sinistres coûteux**. C'est le cas de l'étanchéité :
- Les désordres apparaissent parfois plusieurs années après la réception
- Les réparations nécessitent souvent de démolir/reconstruire une partie de l'ouvrage
- Les infiltrations endommagent la structure ET les finitions, multipliant les coûts

Un simple défaut de joint sur une toiture-terrasse peut engendrer des dizaines de milliers d'euros de travaux correctifs.

## Activités concernées

- **Étancheurs** (toitures-terrasses, membranes bitumineuses ou synthétiques)
- **Couvreurs** (toitures traditionnelles)
- **Maçons** (fondations, sous-sols)
- **Façadiers et plâtriers** (étanchéité air/eau des façades)

## Étanchéité à chaud vs à froid

### 🔥 À chaud
Bitume chauffé appliqué au chalumeau. Risque important d'incendie/accident. Sensible aux malfaçons.
→ **Activité à haut risque, prime plus élevée**, parfois conditions restrictives.

### ❄️ À froid
Membranes auto-adhésives, résines sans flamme. Risque incendie quasi nul. Pose plus sécurisée mais protocole précis à respecter.
→ **Mieux acceptée par les assureurs, tarifs plus compétitifs.**

## Impact en décennale

- Les assureurs analysent la technique de mise en œuvre avant de délivrer une garantie
- Certaines compagnies refusent même l'étanchéité à chaud sans historique solide
- Un courtier spécialisé peut négocier la meilleure couverture et éviter les pièges contractuels

## Conclusion

L'étanchéité ne laisse aucune place à l'improvisation : matériaux certifiés, documentation chantier, assurance adaptée et complète.`
  },
  {
    slug: "rcpro-vs-rc-decennale",
    title: "Les différences entre la RC Pro et la RC Décennale",
    excerpt: "RC Pro et décennale n'ont ni le même rôle ni la même portée. Comparatif, exemples par métier, pourquoi souscrire les deux.",
    date: "2025-08-11",
    dateLabel: "11 août 2025",
    image: "https://primary.jwwb.nl/pexels/22/22614204.jpeg",
    category: "Comprendre la décennale",
    metaTitle: "RC Pro vs Décennale — Différences & exemples | Perspective Assurance",
    metaDescription: "Différences entre RC Pro et décennale : durée, dommages couverts, obligations. Exemples concrets par métier du bâtiment.",
    content: `Dans le bâtiment, on confond souvent **RC Professionnelle** et **Garantie Décennale**. Pourtant, ces deux assurances n'ont ni le même rôle, ni la même portée.

## La RC Professionnelle (RC Pro)

Indemnise les dommages causés à un tiers dans le cadre de votre activité :
- Dommages matériels, corporels ou immatériels (erreur, omission, faute, négligence)
- Inclut souvent la responsabilité civile exploitation (client glissant dans vos locaux, outil tombé du chantier…)
- Concerne : avocats, consultants, architectes, artisans, professions libérales…

Elle s'applique pendant la durée du contrat, renouvelée annuellement.

## La RC Décennale

- **Spécifique au bâtiment et à la construction**
- Couvre les désordres **non visibles à la réception** pendant **10 ans** dès la livraison
- Dommages garantis : atteinte à la solidité, ouvrage impropre à sa destination, problèmes structuraux, infiltration grave, défauts d'étanchéité, affaissement
- **Obligation légale** en France (loi Spinetta 1978, articles 1792+ Code civil)

## Tableau comparatif

| Critère | RC Pro | RC Décennale |
|---|---|---|
| Dommages | Erreurs, accidents, préjudices | Défauts compromettant solidité/usage |
| Durée | Contrat annuel | 10 ans après réception |
| Professionnels | Très large | Bâtiment uniquement |
| Obligation | Variable selon métier | Obligatoire constructeurs |

## Exemples par métier

### Plombier / Chauffagiste
- **RC Pro** : Perce un câble électrique en posant un radiateur
- **Décennale** : Mauvaise soudure encastrée → fuite progressive → SDB inutilisable 2 ans après

### Électricien
- **RC Pro** : Fait tomber une perceuse sur le carrelage neuf
- **Décennale** : Mauvais câblage du tableau → incendie 3 ans après réception

### Maçon
- **RC Pro** : Brouette qui abîme la clôture du voisin
- **Décennale** : Mauvaise réalisation des fondations → fissures structurelles

### Charpentier / Couvreur
- **RC Pro** : Tuile qui tombe et endommage une voiture
- **Décennale** : Défaut de fixation des liteaux → infiltration généralisée

### Carreleur
- **RC Pro** : Renverse un seau de colle sur le parquet
- **Décennale** : Pose sans joints de dilatation → soulèvement à 18 mois

### Menuisier / Agenceur
- **RC Pro** : Raye la baie vitrée lors d'une pose
- **Décennale** : Fenêtres avec défaut d'étanchéité → infiltrations 4 ans après

## Pourquoi souscrire les deux ?

- Protection immédiate pendant l'activité (RC Pro)
- Protection long terme pour les malfaçons invisibles (décennale)
- Certains assureurs proposent des formules combinées : coût et complexité réduits.`
  },
  {
    slug: "maconnerie-decennale",
    title: "L'activité de maçonnerie en assurance décennale",
    excerpt: "Vous êtes maçon ? La décennale est obligatoire dès que vous touchez à la structure d'un bâtiment. Exemples de sinistres et tarifs.",
    date: "2025-07-22",
    dateLabel: "22 juillet 2025",
    image: "https://primary.jwwb.nl/public/g/f/r/temp-rlggvefjiggdfactyuqq/d-cennale-ma-onnerie-standard.webp",
    category: "Décennale par métier",
    metaTitle: "Décennale maçon — Obligations & devis | Perspective Assurance",
    metaDescription: "Maçonnerie : décennale obligatoire pour le gros œuvre. Sinistres types, tarifs, accompagnement courtier en métropole et DOM-TOM.",
    content: `Vous êtes **maçon** et vous cherchez une assurance décennale ? Artisan, auto-entrepreneur ou chef d'entreprise dans le gros œuvre, cette garantie est obligatoire dès que vous touchez à la structure d'un bâtiment.

## Pourquoi est-elle obligatoire ?

Depuis la **loi Spinetta (1978)**, tout pro réalisant des travaux de gros œuvre engage sa responsabilité **10 ans** après réception. La décennale couvre les dommages graves affectant :
- La solidité de l'ouvrage (fondations, murs, dalles)
- Sa destination (maison inhabitable à cause de fissures majeures)

## Exemples de sinistres courants

🔸 **Fissures structurelles** : larges fissures verticales sur murs porteurs 18 mois après construction, dues à un mauvais terrassement des fondations. ✔ Pris en charge.

🔸 **Affaissement de dalle béton** : dalle qui s'enfonce de plusieurs cm 2 ans après — dosage béton insuffisant, sol mal préparé. ✔ Couvert.

🔸 **Effondrement de mur de soutènement** : pluies + mauvais ancrage + absence d'évacuation. ✔ Sinistre grave.

🔸 **Infiltrations par défaut de maçonnerie** : sous-sol mal étanchéifié, pièces inutilisables. ✔ Ouvrage impropre à sa destination.

## Travaux concernés

- Fondations, murs porteurs, chaînages
- Dalles, planchers, poteaux, poutres
- Piscines maçonnées (dans certains cas)
- Escaliers en béton
- Murs de soutènement
- Chapes, terrasses maçonnées

⚠️ Les petits travaux de second œuvre (enduit, cloison légère) ne sont pas toujours couverts. **Vérifiez la nomenclature d'activité de votre contrat.**

## Combien ça coûte ?

Les tarifs varient selon :
- Statut (auto-entrepreneur, SARL, SASU)
- Chiffre d'affaires
- Expérience et antécédents
- Zone géographique (DOM-TOM, métropole)

Une couverture mal définie coûte souvent bien plus cher qu'une bonne protection.`
  },
  {
    slug: "amenagement-cuisines-salles-bains-decennale",
    title: "Aménagement de cuisines et salles de bains : quels risques en décennale ?",
    excerpt: "Pose d'éléments fixes, raccordements, étanchéité, cloisons : l'agenceur est exposé à de vrais risques décennaux. Tour d'horizon.",
    date: "2025-07-14",
    dateLabel: "14 juillet 2025",
    image: "https://primary.jwwb.nl/public/g/f/r/temp-rlggvefjiggdfactyuqq/assurance-d-cennale-am-nagement-cuisine-salle-de-bains-high.webp",
    category: "Décennale par métier",
    metaTitle: "Agenceur cuisine/SDB — Risques décennale | Perspective Assurance",
    metaDescription: "Agencement cuisine et SDB : pose, plomberie, étanchéité, cloisons. Tous les risques décennaux qui peuvent vous concerner.",
    content: `L'activité d'agenceur de cuisines ou de salles de bains est souvent perçue comme de la simple finition. Pourtant, elle implique fréquemment :
- La pose d'éléments fixes (meubles suspendus, plans de travail)
- Des raccordements en plomberie ou électricité
- Des travaux d'étanchéité dans les pièces d'eau
- Des interventions sur cloisons ou supports muraux

👉 Dès que vos travaux peuvent impacter la solidité de l'ouvrage ou son usage normal, vous êtes soumis à l'**obligation d'assurance décennale**.

## Que couvre la décennale ?

- Dommages affectant la solidité (affaissement, fissures, instabilité)
- Ou rendant l'ouvrage impropre à sa destination (fuite invisible, étanchéité défaillante, chute de mobilier intégré)

Valable **10 ans** à compter de la réception.

## Les interventions qui engagent votre décennale

### 🔹 Pose de receveur de douche ou baignoire
Étanchéité mal réalisée (natte absente, joints défectueux) → infiltrations sous carrelage ou dans murs → humidité, moisissures, dégâts structurels.

### 🔹 Fixation de meubles suspendus
Fixations sous-dimensionnées → arrachement → dégâts matériels voire corporels. Équipements indissociables du bâti.

### 🔹 Raccordement plomberie
Étanchéité défaillante ou raccord mal serré → fuite lente invisible → mur humide, infiltration chez le voisin, dégradation ossature bois.

### 🔹 Pose de plan de travail lourd
Pierre/céramique/bois massif mal fixé → fragilise le mur porteur ou bascule.

### 🔹 Modification de cloisons
En modifiant les volumes, vous touchez à l'agencement structurel : fissures, effondrement, désordres dans les années suivantes.

### 🔹 Encastrement d'appareils électriques
Four, micro-ondes, prises encastrés sans respecter la norme NF C 15-100 → court-circuit, début d'incendie.

### 🔹 Carrelage en pièce humide
Étanchéité négligée ou support instable → fissures, décollements, infiltrations.

## En résumé

Dès que vous touchez à l'eau, l'électricité, des éléments fixes ou la structure d'une pièce, vous devez être couvert par une décennale adaptée à votre métier.`
  },
  {
    slug: "charpente-couverture-decennale",
    title: "Assurance décennale charpentier couvreur : risques couverts",
    excerpt: "Affaissement, fuites, fixations défectueuses, DTU non respectés : tour d'horizon des sinistres typiques en charpente-couverture.",
    date: "2025-07-06",
    dateLabel: "6 juillet 2025",
    image: "https://primary.jwwb.nl/public/g/f/r/temp-rlggvefjiggdfactyuqq/assurance-d-cennale-couvreur-high.jpg",
    category: "Décennale par métier",
    metaTitle: "Décennale charpentier couvreur | Perspective Assurance",
    metaDescription: "Charpente-couverture : affaissements, infiltrations, DTU, isolation. Risques décennaux et conseils pour bien s'assurer.",
    content: `Le métier de **charpentier couvreur** est au cœur de la solidité et de l'étanchéité des bâtiments. Une erreur peut avoir des conséquences majeures sur la structure ou la protection de l'ouvrage. La garantie décennale, obligatoire depuis la loi Spinetta, protège les pros pendant 10 ans.

## Les principaux risques en décennale

### 1. Affaissement ou déformation de la charpente
Mauvaise conception, dimensionnement insuffisant, défauts de pose → fléchissements ou ruptures. **Solidité de l'ouvrage engagée.**

### 2. Fuites de toiture et infiltrations
Défaut d'étanchéité (recouvrement de tuiles, soudures zinc, membranes mal posées) → infiltrations rendant le bâtiment impropre à sa destination.

### 3. Fixations défectueuses
Éléments arrachés par le vent ou désolidarisés avec le temps → danger occupants, intégrité de l'ouvrage.

### 4. Non-respect des DTU
Documents Techniques Unifiés (DTU 31.1, DTU 40…) non respectés = malfaçon engageant la décennale.

### 5. Défaut d'isolation ou ventilation
Condensation, moisissures, pourrissements → combles inhabitables, structure dégradée.

## Exemples concrets de sinistres pris en charge

✅ Ferme de charpente affaissée après 3 ans : solidité compromise → pris en charge.
✅ Infiltrations dans les combles liées à une erreur de pose : dommage grave → couvert.
✅ Tempête détache un pan de couverture mal fixé : mise en œuvre fautive → garantie activée.

## Comment éviter les litiges

- 📌 Souscrire votre assurance **avant tout chantier**
- 📌 Respecter les DTU et les règles de l'art
- 📌 Déclarer précisément vos activités à l'assureur
- 📌 Documenter vos chantiers (photos, rapports, attestations)
- 📌 Utiliser des matériaux certifiés et traçables`
  }
];

export const getPostBySlug = (slug) => POSTS.find(p => p.slug === slug);
export const getCategories = () => Array.from(new Set(POSTS.map(p => p.category)));
